import axios from 'axios';
import { Toast } from 'vant';
import qs from 'qs';
import Store from '@/store';
import md5 from 'js-md5';

console.log(process.env.VUE_APP_BASE_API);
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 99999,
});
console.log(process.env);
var toast;
request.interceptors.request.use((config) => {
  toast = Toast.loading({
    duration: 0,
    message: '数据加载中...',
    forbidClick: true,
  });

  const apikey = "oVw5lgBQ32mygdfZUvYuKAbYtm7DRN37";
  const apitime = new Date().getTime();
  const apitoken = md5(md5(apikey+apitime));
  Object.assign(config.headers, {
    'apitoken': apitoken,
    'apitime':apitime
  });

   const userid = localStorage.getItem('setUserid') || Store.getters['auth/userId'];
          
  //const userid ="1425772969427312641";
  if (config.method === 'post') {
    Object.assign(config.headers, {
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    console.log(config);
    if (userid) {
      Object.assign(config.data, { userid });
    }
    // Object.assign(config.data, { userid: '1425772969427312641' });
    // eslint-disable-next-line no-param-reassign
    config.data = qs.stringify(config.data);
  } else if (config.method === 'get') {
    if (userid) {
      Object.assign(config.params, { userid });
    }
  }
  return config;
});

request.interceptors.response.use((response) => {
   toast.clear();
  if (response.status === 200) {
    return response.data;
  }
  Toast.fail('网络请求失败!');
  return response;
});

export default request;
